import { Component, Inject, PLATFORM_ID } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { StorageEnum } from '../../shared/enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { RouterModule } from '@angular/router';
import { CurrencyPipe, DatePipe, isPlatformBrowser, TitleCasePipe } from '@angular/common';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { MatCardModule } from '@angular/material/card';
import { type Account } from '../../shared/models/account';
import { CreditPipe } from '../../shared/pipes/credit.pipe';
import { UserProfile } from '../../shared/models/user-profile';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
import { isToday, isValid, isWithinInterval, subDays } from 'date-fns';
import { MatPaginatorModule } from '@angular/material/paginator';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AuthService } from '../../shared/services/auth.service';
import { catchError, concatMap, EMPTY, map, type Observable } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { Nav } from '../../shared/enums/nav.enum';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-multi-account-summary',
  imports: [
    NotificationComponent, //
    MatCardModule,
    MatExpansionModule,
    MatTooltipModule,
    RouterModule,
    MatPaginatorModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    PageHeaderComponent,
  ],
  templateUrl: './multi-account-summary.component.html',
  styleUrl: './multi-account-summary.component.scss',
  providers: [TitleCasePipe, DatePipe, CreditPipe, CurrencyPipe],
})
export class MultiAccountSummaryComponent {
  pageLabels: any;
  isBrowser = false;
  pageReady = false;
  isMobile = false;
  multiAccount: UserProfile;
  userName: any = '';
  userPW = '';
  searchForm: any;
  pageHeader = new PageHeader();
  pageName = Nav.MultiAccountSummary;
  multiState = {
    SearchString: '',
    Accounts: [] as any[],
    Page: 1,
    StartIndex: 1,
    EndIndex: 30,
  };

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly auth: AuthService,
    private readonly fb: FormBuilder,
    private readonly cms: CmsService,
    private readonly creditP: CreditPipe,
    private readonly currencyP: CurrencyPipe,
    private readonly dateP: DatePipe,
    private readonly notifi: NotificationsService,
    private readonly storage: StorageService,
    private readonly titleP: TitleCasePipe,
    private readonly utils: UtilService,
    private readonly seoS: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.multiAccount = this.storage.getSession(StorageEnum.MultiAccountResponse);
      this.userPW = this.storage.getSession(StorageEnum.UserPW);
      this.userName = this.storage.getSession(StorageEnum.UserName);
      this.isMobile = this.utils.isMobile(992);
      this.searchForm = this.fb.group({
        Search: this.multiState.SearchString,
      });
    } else {
      this.multiAccount = new UserProfile();
    }
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      window.addEventListener('resize', () => {
        this.isMobile = this.utils.isMobile(992);
      });
    }

    this.cms
      .getContent('oas-multi-account-2', 'Multi Account')
      .pipe(
        concatMap((data: any) => {
          this.pageLabels = this.cms.flattenBuilderReferencesPreservingKeys(data);
          this.pageHeader.ShowAccountInfo = false;
          this.pageHeader.Message = this.pageLabels.header;
          this.seoS.setSeoTags(data.seo);

          if (this.isBrowser) {
            return this.resetAUPData();
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe(() => {
        this.pageReady = true;
        this.utils.hideSpinner();
      });
  }

  mapMultiAccount(accounts: Account[]): any {
    const retVal = accounts.map((acc: Account) => {
      const [accountSA, isSeasonal] = this.auth.getServiceAddress(acc);
      acc.BillDueDate = acc.BillDueDate?.replaceAll('-', '/');
      accountSA.SaEndDate = accountSA.SaEndDate ? accountSA.SaEndDate + 'T00:00' : '';
      const today = new Date().setHours(0, 0, 0, 0);

      const displayData = {
        Nickname: {
          ...this.pageLabels.manageAccountLink,
          displayText: acc.NickName,
        },
        Address: this.titleP.transform(accountSA?.Address1?.replace(/\s+/g, ' ').trim()),
        AccountNumber: {
          ...this.pageLabels.accountSummaryLink,
          displayText: acc.AccountNumber.padStart(10, '0'),
        },
        Balance: this.creditP.transform(this.currencyP.transform(acc.AccountBalance)),
        PayNow: this.pageLabels.paymentLink,
        DueDate: isValid(new Date(acc.BillDueDate))
          ? this.dateP.transform(acc.BillDueDate, 'MM/dd/yyyy')
          : acc.BillDueDate,
        Manage: this.pageLabels.manageAccountLink,
        Activity: this.pageLabels.viewActivityLink,
      };

      switch (accountSA.SaStatusFlag) {
        case '10':
          this.utils.consoleLog('account is pending');
          displayData.Nickname = {
            ...this.pageLabels.pendingLink,
            displayText: acc.NickName,
          };

          displayData.AccountNumber = {
            ...this.pageLabels.pendingLink,
            displayText: acc.AccountNumber.padStart(10, '0'),
          };

          if (acc.AutoPay) {
            displayData.PayNow = {
              ...this.pageLabels.pendingLink,
              displayText: this.pageLabels.autopayEnrolledText,
            };
          } else {
            displayData.PayNow = {
              ...this.pageLabels.pendingLink,
              displayText: this.pageLabels.autopayEnrollText,
            };
          }

          displayData.Balance = this.pageLabels.pendingText;
          displayData.DueDate = '';

          displayData.Manage = {
            ...this.pageLabels.pendingLink,
            displayText: this.pageLabels.manageAccountLinkText,
          };

          displayData.Activity = '';
          break;
        case '20':
        case '50':
          this.utils.consoleLog('account is active');
          // Pay now
          if (acc.AutoPay) {
            displayData.PayNow = {
              ...this.pageLabels.accountSummaryLink,
              displayText: this.pageLabels.autopayEnrolledText,
            }; // go to summary page
          } else {
            if (acc.AccountBalance > 0) {
              displayData.PayNow = this.pageLabels.paymentLink; // go to payment page
            } else {
              displayData.PayNow = '';
            }
          }

          // Due Date
          if (acc.AccountBalance > 0) {
            if (acc.InCollection && acc.AccountBalance > 50) {
              displayData.DueDate = this.pageLabels.pastDueText;
            } else if (isValid(new Date(acc.BillDueDate)) && acc.BillDueDate && isToday(new Date(acc.BillDueDate))) {
              displayData.DueDate = this.pageLabels.dueNowText;
            } else if (isValid(new Date(acc.BillDueDate)) && acc.BillDueDate) {
              displayData.DueDate = this.dateP.transform(acc.BillDueDate, 'MM/dd/yyyy') ?? '';
            }
          } else {
            displayData.DueDate = '';
          }

          // Manage Account
          if (acc.GCSPStatus === 'SOF-IN-PROG') {
            displayData.Manage = {
              ...this.pageLabels.accountSummaryLink,
              displayText: this.pageLabels.reconnectText,
            }; // go to reconnect
          } else {
            displayData.Manage = this.pageLabels.manageAccountLink;
          }

          // View activity
          displayData.Activity = this.pageLabels.viewActivityLink;
          break;
        case '40':
          this.utils.consoleLog('account is stopped');
          // make payment
          if (acc.AutoPay) {
            displayData.PayNow = {
              ...this.pageLabels.accountSummaryLink,
              displayText: this.pageLabels.autopayEnrolledText,
            };
          } else {
            if (acc.AccountBalance > 0) {
              displayData.PayNow = this.pageLabels.paymentLink;
            } else {
              displayData.PayNow = '';
            }
          }

          // Due Date
          if (acc.AccountBalance > 0) {
            displayData.DueDate = this.pageLabels.dueNowText;
          } else {
            if (isValid(new Date(acc.BillDueDate)) && acc.BillDueDate) {
              displayData.DueDate = this.dateP.transform(acc.BillDueDate, 'MM/dd/yyyy') ?? '';
            } else {
              displayData.DueDate = '';
            }
          }

          // manage account
          if (accountSA.SaTypeCode === 'RESGAS' || accountSA.SaTypeCode === 'COMMGAS') {
            const inInterval = isWithinInterval(new Date(accountSA.SaEndDate), {
              start: subDays(today, 90),
              end: today,
            });

            if (inInterval && acc.AccountBalance <= 0) {
              displayData.Manage = {
                ...this.pageLabels.accountSummaryLink,
                displayText: this.pageLabels.reconnectText,
              };
            } else {
              displayData.Manage = this.pageLabels.manageAccountLink;
            }
          } else {
            displayData.Manage = this.pageLabels.manageAccountLink;
          }
          break;
        case '60':
        case '70':
          if (accountSA.SaTypeCode === 'COMMGAS' || accountSA.SaTypeCode === 'RESGAS') {
            if (isSeasonal && !acc.Active) {
              this.utils.consoleLog('account is seasonal closed');
              displayData.AccountNumber = {
                ...this.pageLabels.seasonalLink,
                displayText: acc.AccountNumber.padStart(10, '0'),
              };
              displayData.PayNow = '';
              displayData.Balance = this.pageLabels.seasonalText;
              displayData.DueDate = '';
              displayData.Manage = {
                ...this.pageLabels.seasonalLink,
                displayText: this.pageLabels.reconnectText,
              };
              displayData.Activity = {
                ...this.pageLabels.seasonalLink,
                displayText: this.pageLabels.activityLinkText,
              };
            } else {
              this.utils.consoleLog('account is not seasonal closed');
              displayData.AccountNumber = {
                ...this.pageLabels.closedLink,
                displayText: acc.AccountNumber.padStart(10, '0'),
              };
              displayData.PayNow = '';
              displayData.Balance = this.pageLabels.closedText;
              displayData.DueDate = '';

              const inInterval = isWithinInterval(new Date(accountSA.SaEndDate), {
                start: subDays(today, 90),
                end: today,
              });
              if (inInterval) {
                displayData.Manage = {
                  ...this.pageLabels.closedLink,
                  displayText: this.pageLabels.reconnectText,
                };
              } else {
                displayData.Manage = {
                  ...this.pageLabels.closedLink,
                  displayText: this.pageLabels.startServiceText,
                };
              }

              displayData.Activity = {
                ...this.pageLabels.closedLink,
                displayText: this.pageLabels.activityLinkText,
              };
            }
          } else {
            this.utils.consoleLog('account is seasonal/closed and not commgas or resgas');
            displayData.AccountNumber = {
              ...this.pageLabels.closedLink,
              displayText: acc.AccountNumber.padStart(10, '0'),
            };
            displayData.PayNow = '';
            displayData.Balance = this.pageLabels.closedText;
            displayData.DueDate = '';
            displayData.Manage = {
              ...this.pageLabels.closedLink,
              displayText: this.pageLabels.startServiceText,
            };
            displayData.Activity = {
              ...this.pageLabels.closedLink,
              displayText: this.pageLabels.viewActivityLink.displayText,
            };
          }
          break;
        default:
          this.utils.consoleLog('account hit default case');
          break;
      }

      return displayData;
    });

    return retVal;
  }

  pageChanged(pageData: any): void {
    this.utils.showSpinner();
    window.scrollTo(0, 0);
    const startIndex = 1 + (pageData.pageIndex + 1) * pageData.pageSize - pageData.pageSize;
    const endIndex = startIndex + pageData.pageSize - 1;

    this.auth
      .getAUP(this.userName ?? '', this.userPW, startIndex + '', endIndex + '')
      .pipe(
        catchError((err: any) => {
          // figure out error stuff
          this.utils.consoleGroup('PageChanged: Err getting new accounts', err);
          this.utils.hideSpinner();
          return EMPTY;
        }),
      )
      .subscribe((data) => {
        this.storage.setSession(StorageEnum.MultiAccountResponse, data);
        this.multiState.Page = pageData.pageIndex + 1;
        this.multiState.StartIndex = startIndex;
        this.multiState.EndIndex = endIndex;
        this.multiState.Accounts = this.mapMultiAccount(data.Accounts);
        this.storage.setSession(StorageEnum.MultiState, this.multiState);
        this.utils.hideSpinner();
      });
  }

  searchAccount(): void {
    this.notifi.clearAllNotifications();
    const accountNumber = this.searchForm.get('Search').value;
    if (this.utils.isNullOrWhitespace(accountNumber)) {
      return;
    }
    this.utils.showSpinner();
    this.auth
      .searchAccountAUA(accountNumber, this.userName ?? '')
      .pipe(
        catchError((err: any) => {
          // figure out error stuff
          this.utils.consoleGroup('searchAcc: Err searching account', err);
          // actual error. show message?
          this.notifi.addNotification(
            "An error occurred searching for account '" + accountNumber + "'.",
            NotificationType.Alert,
            Nav.MultiAccountSummary,
          );
          this.searchForm.get('Search').setValue('');
          this.utils.hideSpinner();
          return EMPTY;
        }),
      )
      .subscribe((data) => {
        if (data?.Error?.ErrorStatus === 'F') {
          // show no accounts
          this.utils.consoleLog('no account found');
          this.multiState.Accounts = [];
        } else {
          this.multiState.SearchString = accountNumber;
          this.multiState.Accounts = this.mapMultiAccount(data.Accounts);
          this.multiAccount.Accounts = data.Accounts;
          this.storage.setSession(StorageEnum.MultiAccountResponse, this.multiAccount);
          this.storage.setSession(StorageEnum.MultiState, this.multiState);
        }

        this.utils.hideSpinner();
      });
  }

  clearSearch(): void {
    this.resetAUPData().subscribe(() => {
      this.utils.hideSpinner();
    });
  }

  private resetAUPData(): Observable<any> {
    this.searchForm.get('Search').setValue('');

    if (this.multiState.Accounts?.length > 1) {
      return EMPTY;
    }

    this.utils.showSpinner();

    return this.auth
      .getAUP(this.userName ?? '', this.userPW, this.multiState.StartIndex + '', this.multiState.EndIndex + '')
      .pipe(
        catchError((err: any) => {
          // figure out error stuff
          this.utils.consoleGroup('clear search: Err getting new accounts', err);
          this.utils.hideSpinner();
          return EMPTY;
        }),
        map((data) => {
          this.multiAccount = data;
          this.storage.setSession(StorageEnum.MultiAccountResponse, data);
          this.multiState.SearchString = '';
          this.multiState.Accounts = this.mapMultiAccount(data.Accounts);
          this.storage.setSession(StorageEnum.MultiState, this.multiState);
        }),
      );
  }
}
